exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:1500px){#f-demo-home .main{float:left;width:calc(100% - 350px)}#f-demo-home .left{float:right;width:320px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./client/containers/home/home.css
 ** module id = 567
 ** module chunks = 0
 **/